var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77445_4541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4425 2.35309L14.4183 2.38068C13.1706 3.81812 12.3838 5.57583 12.1421 7.46566V7.47486L12.0894 7.55179L12.0376 7.47486V7.46566C11.7951 5.57583 11.0082 3.81812 9.76058 2.38068L9.73633 2.35309L12.0894 0L14.4425 2.35309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0852 19.507C12.0886 19.5171 12.0919 19.5271 12.0953 19.5371C12.0986 19.5271 12.102 19.5171 12.1053 19.507C12.6187 16.4106 15.0487 13.9613 18.1352 13.4195L20.255 7.97156C16.0689 7.97156 12.3403 11.3348 12.0953 15.6839C11.8503 11.3348 8.1216 7.97156 3.93555 7.97156L6.05533 13.4195C9.14178 13.9613 11.5718 16.4106 12.0852 19.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6935 25.419C13.2646 23.3853 15.1402 21.9638 17.2542 21.9638C17.6179 21.9638 18.1773 22.0257 18.7593 22.2146L24.1796 16.7994L24.0659 16.7358C22.8041 16.0326 21.5105 15.6906 20.1123 15.6906C16.178 15.6906 12.7913 18.5537 12.0889 22.2682C11.3865 18.5537 7.99902 15.6906 4.0655 15.6906C2.66736 15.6906 1.37375 16.0326 0.111911 16.7358L-0.000976562 16.7985L5.41681 22.2163C6.10919 21.9663 6.55322 21.9638 6.927 21.9638C9.04094 21.9638 10.9166 23.3853 11.4877 25.419L11.5462 25.6264C11.6148 25.9249 11.6541 26.2284 11.6658 26.5303V26.981C11.5345 29.2973 9.75924 31.1637 7.44462 31.4113L7.39946 31.4163L6.81495 31.9999H17.3671L16.7825 31.4163L16.7374 31.4113C14.4236 31.1637 12.6483 29.2973 12.5171 26.981V26.5303C12.5271 26.2276 12.5664 25.9249 12.635 25.6264L12.6935 25.419Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77445_4541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1806,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.931be0db90ef6fbbd76ac18c5be51956.svg";
export { ForwardRef as ReactComponent };